export const MODULE_META = {
    production: { label: 'Production', color: '#2563eb' },
    quality: { label: 'Quality', color: '#dc2626' },
    warehouse: { label: 'Warehouse', color: '#d97706' },
    inventory: { label: 'Inventory', color: '#059669' },
    sales: { label: 'Sales', color: '#7c3aed' },
    procurement: { label: 'Procurement', color: '#0891b2' },
    finance: { label: 'Finance', color: '#475569' },
};

export const INSIGHT_META = {
    outlier: { label: 'Outlier', color: '#dc2626' },
    trend: { label: 'Trend', color: '#2563eb' },
    correlation: { label: 'Correlation', color: '#0f766e' },
    distribution: { label: 'Distribution', color: '#ea580c' },
    comparison: { label: 'Comparison', color: '#7c3aed' },
    general: { label: 'Insight', color: '#64748b' },
};

export const SUPPORTED_MODULES = [
    'Production',
    'Quality',
    'Warehouse',
    'Inventory',
    'Sales',
    'Procurement',
    'Finance',
];

export const SUGGESTED_QUESTION_LANGS = [
    { id: 'en', label: 'EN' },
    { id: 'zh', label: '中文' },
];

export const SUGGESTED_QUESTIONS = {
    en: [
        'What is the average OEE ranking for each machine? Draw a bar chart',
        'What is the pass rate for IQC incoming inspections?',
        'What is the storage-location occupancy rate for each warehouse area? Draw a bar chart',
        'What is the current inventory balance of each material?',
        'What is the finished-goods delivery quantity for each customer?',
        'List the purchase price and supplier for each raw material',
    ],
    zh: [
        '各设备的平均OEE排名是多少？画柱状图',
        'IQC来料检验的合格率是多少？',
        '各仓库区域的库位占用率是多少？画柱状图',
        '当前各物料的库存余额是多少？',
        '各客户的成品发货数量是多少？',
        '各原料的采购价格和供应商有哪些？',
    ],
};

